module.exports = require('./helpers/bundle-url').getBundleURL('4BKs0') + "logo.c51670a8.svg";